module.exports = __webpack_public_path__ + "static/media/VectorQuote.776b3f85.svg";